export const BetProperSet = (gameInfo, amount, bet1, bet2 = null, bet3 = null, gameType = null, position = null, shioData = null, betType = null) => {
    let parsAmount = parseInt(amount)

    let kombinasiData = {
        'as' : 'As',
        'kop' : 'Kop',
        'genap' : 'Genap',
        'ganjil' : 'Ganjil',
        'kecil' : 'Kecil',
        'besar' : 'Besar',
        'ekor' : 'Ekor',
        'kepala' : 'Kepala',
        'depan' : 'Depan',
        'tengah' : 'Tengah',
        'belakang' : 'Belakang',
        'kembang' : 'Kembang',
        'kempis' : 'Kempis',
        'kembar' : 'Kembar',
        'silang' : 'Silang',
        'homo' : 'Homo',
        'tepi' : 'Tepi'
    }

    let colokJitu = {
        'as' : 'A',
        'kop' : 'B',
        'kepala' : 'C',
        'ekor' : 'D',
    }
    let betNum = ''
    let betArray = []
    if(betType === 222) {
        if(gameInfo === "4D" || gameInfo == "3D Belakang" || gameInfo == "3D  Depan" || gameInfo == "2D Belakang" || gameInfo == "2D  Depan" || gameInfo == "2D  Tengah") {
            betNum = bet1
            betArray = [betNum, parsAmount, "4d3d2d", "success"]
        }
        else if(gameInfo === "50-50") {
            betNum = bet1.replace(/\s+/g, "_");
            betArray = [betNum, parsAmount, "5050", "success"]
        }
        else if(gameInfo === "50-50 2D") {
            betNum = bet1;
            betArray = [betNum, parsAmount, "50502d", "success"]
        }
        else if(gameInfo === "Colok Jitu") {
            betNum = bet1;
            betArray = [`${betNum}-${colokJitu[position]}`, parsAmount, "colokjitu", "success"]
        }
        else if(gameInfo === "Shio") {
            betNum = parseInt(bet1.split('_')[0]);
            betArray = [betNum, parsAmount, "shio", "success"]
        }
        else if(gameInfo === "Bebas") {
            betNum = bet1;
            betArray = [betNum, parsAmount, "colokbebas", "success"]
        }
        else if(gameInfo === "Bebas 2D") {
            betNum = parseInt(`${bet1}${bet2}`);
            betArray = [betNum, parsAmount, "colokbebas2d", "success"]
        }
        else if(gameInfo === "Naga") {
            betNum = parseInt(`${bet1}${bet2}${bet3}`);
            betArray = [betNum, parsAmount, "coloknaga", "success"]
        }
        else if(gameInfo === "Tengah Tepi") {
            betNum = bet1;
            betArray = [betNum, parsAmount, "tengahtepi", "success"]
        }
        else if(gameInfo === "Kombinasi") {
            let splitNumb1 = bet1.split(' ')
            let splitNumb2 = bet2.split(' ')
            let betNum1 = `${kombinasiData[splitNumb1[0]]}-${kombinasiData[splitNumb1[1]]}`;
            let betNum2 = `${kombinasiData[splitNumb2[0]]}-${kombinasiData[splitNumb2[1]]}`;
            betNum = `${betNum1}+${betNum2}`;
            betArray = [betNum, parsAmount, "kombinasi", "success"]
        }
        return betArray
    }
    else {
        if(gameType === "4D/3D/2D" || gameType === "Tengah Tepi" || gameType === "50-50 2D" || gameType === "50-50" || gameType === "Colok Bebas" || gameType === "Dasar"  || gameType === "Shio") {
            if(gameInfo == "3D Belakang") {
                betNum = "X" + bet1
            }
            else if(gameInfo == "3D  Depan") {
                betNum = bet1 + "X"
            }
            else if(gameInfo == "2D Belakang") {
                betNum = "XX" + bet1
            }
            else if(gameInfo == "2D  Depan") {
                betNum = bet1 + "XX"
            }
            else if(gameInfo == "2D  Tengah") {
                betNum = "X" + bet1 + "X"
            }
            else {
                if(gameType === "50-50") {
                    betNum = bet1.replace(/\s+/g, "_");
                }
                else if(gameType === "Tengah Tepi") {
                    betNum = kombinasiData[bet1];
                }
                else if(gameType === "Shio") {
                    let newBet = bet1.split('_')[1]
                    betNum = shioData[newBet];
                }
                else {
                    betNum = bet1;
                }
            }
            if(gameType === "Colok Bebas") {
                betArray = [betNum, parsAmount]
            }
            else {
                betArray = [betNum, parsAmount, 'success']
            }
        }
        else if(gameType === "Colok Naga") {
            betArray = [parseInt(`${bet1}${bet2}${bet3}`), parsAmount]
        }
        else if(gameType === "Colok Jitu") {
            betArray = [`${bet1}-${colokJitu[position]}`, parsAmount]
        }
        else if(gameType === "Colok Bebas 2D") {
            betArray = [parseInt(`${bet1}${bet2}`), parsAmount]
        }
        else if(gameType === "Kombinasi") {
            let splitNumb1 = bet1.split(' ')
            let splitNumb2 = bet2.split(' ')
            let betNum1 = `${kombinasiData[splitNumb1[0]]}_${kombinasiData[splitNumb1[1]]}`;
            let betNum2 = `${kombinasiData[splitNumb2[0]]}_${kombinasiData[splitNumb2[1]]}`;
            betArray = [`${betNum1}-${betNum2}`, parsAmount, 'success']
        }
        else if(gameType === "Kembang / Kempis / Kembar" || gameType === "Silang / Homo") {
            let splitNumb1 = bet1.split(' ')
            let betNum1 = `${kombinasiData[splitNumb1[0]]}-${kombinasiData[splitNumb1[1]]}`;
            betArray = [betNum1, parsAmount, 'success']
        }
        return betArray
    }
}